import { useState } from 'react'
import Box from '@mui/material/Box'
import { Survey } from 'pages/Survey/Survey'
import { getIsSkippedSurveys, setIsSkippedSurveys } from 'pages/Survey/utils'
import { getResponsiveSize } from 'theme/styles.utils'
import { useCurrentUser } from 'utils/hooks/useCurrentUser'
import { FCWithChildren } from 'utils/types/FCWithChildren'

export const SurveyProvider: FCWithChildren = ({ children }) => {
  const [isSkip, setIsSkip] = useState(getIsSkippedSurveys())
  const [sentSurveys, setSentSurveys] = useState<number[]>([])
  const user = useCurrentUser()
  const surveys = user?.available_surveys?.filter((s) => !sentSurveys?.includes(s)) || []

  const handleSkip = () => {
    setIsSkip(true)
    setIsSkippedSurveys(true)
  }

  if (!user) return <>{children}</>
  if (surveys.length === 0 || isSkip) return <>{children}</>

  return (
    <Box
      sx={(_) => ({
        background: _.palette.background.default,
        height: '100%',
        maxWidth: '100%',
        fontFamily: 'ProximaNovaCond',
      })}
    >
      <Box
        sx={(theme) => ({
          maxWidth: { xs: '100%', md: getResponsiveSize(700) },
          margin: 'auto',
          paddingTop: theme.spacing(3),
          paddingBottom: theme.spacing(3),
        })}
      >
        <Survey
          surveyId={surveys[0]}
          onSkip={handleSkip}
          onSent={(id: number) => setSentSurveys((prev) => [...prev, id])}
        />
      </Box>
    </Box>
  )
}
